import { store } from ".."
import api from "../../providers/api"
import history from "../../providers/history"
import { GetObject } from "../../providers/storage"
import { IAuthenticatedUser } from "../authentication/types"
import { fileUploadSetPercentage } from "./slice"

//UPLOAD ROOM PHOTOS
export const roomPhotoSaveRequestService = (roomId: string, path: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.put(`rooms/photos/${roomId}/${path}`, null,
        {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
}
// ROOM PHOTOS
export const roomPhotosListRequestService = (roomId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.get(`rooms/${roomId}/photos?type=photos`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}
// DELETE ROOM PHOTO
export const roomPhotosDeleteRequestService = (photoId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`rooms/photos/${photoId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}
//UPLOAD ROOM FLIR PHOTOS
export const roomFlirPhotoSaveRequestService = (roomId: string, photoPath: string, flirPath: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.put(`rooms/flir-photo/${roomId}/${photoPath}/${flirPath}`, null,
        {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
}
//ROOM FLIR PHOTOS
export const roomFlirPhotosListRequestService = (roomId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.get(`rooms/${roomId}/photos?type=flir`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}
// DELETE ROOM FLIR PHOTO 
export const roomFlirPhotosDeleteRequestService = (idPhoto: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`rooms/flir-photo/${idPhoto}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}
//UPLOAD ITEM PHOTOS
export const itemPhotoSaveRequestService = (itemId: string, path: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.put(`items/photos/${itemId}/${path}`, null,
        {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
}
// DELETE ITEM PHOTO
export const itemPhotosDeleteRequestService = (photoId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`items/photos/${photoId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}
// ITEMS 
export const itemPhotosListRequestService = (itemId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.get(`items/${itemId}/photos?type=itemPhotos`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}
// ITEMS PHOTO FLIR LIST
export const itemFlirPhotosListRequestService = (itemId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.get(`items/${itemId}/photos?type=itemFlir`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}
//UPLOAD ITEM PHOTO FLIR
export const itemFlirPhotoSaveRequestService = (itemId: string, path: string, flirPath: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.put(`items/flir-photos/${itemId}/${path}/${flirPath}`, null,
        {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
}
// DELETE ITEM PHOTO FLIR
export const itemPhotosFlirDeleteRequestService = (flirPhotoId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`items/flir-photos/${flirPhotoId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}
// UPLOAD 
export const fileUploadService = (id: string, data: FormData) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.post('uploads/', data, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        },
        onUploadProgress: (event) => {
            let progress: number = Math.round(
                (event.loaded * 100) / event.total
            );

            store.dispatch(fileUploadSetPercentage({
                id,
                percentage: progress
            }))
        },
    })
}
// DOWLOAD
export const fileDownloadService = (link: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.get(link, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        },
        responseType: 'blob'
    })
}

